var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M21.629 26.354c.338 0 .58-.23.58-.47V17.41c0-.24-.242-.469-.58-.469h-11.55c-.337 0-.579.229-.579.47v8.475c0 .24.242.469.58.469h11.549zM8.675 14.218V10c0-4.13 3.257-7.5 7.3-7.5 4.044 0 7.3 3.369 7.3 7.5a1.5 1.5 0 0 1-3 0c0-2.497-1.936-4.5-4.3-4.5-2.363 0-4.3 2.004-4.3 4.5v3.94h9.954c1.96 0 3.58 1.534 3.58 3.47v8.475c0 1.935-1.62 3.469-3.58 3.469h-11.55c-1.959 0-3.579-1.535-3.579-3.47V17.41c0-1.444.903-2.665 2.175-3.191z"}));
}

Lock.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Lock;

Lock.default = Lock;
